<p>
  manage-tenant works!
</p>
